// extracted by mini-css-extract-plugin
module.exports = {"container":"emptyCard_container__1co0k","logo":"emptyCard_logo__3s6Np","large":"emptyCard_large__1Zf1z","small__div":"emptyCard_small__div__16I1x","small":"emptyCard_small__2RRzp"};